import { getApiActionTypes } from '../../../../shared/store/storeHelpers';

export const fetchCustomReportsTypes = getApiActionTypes('FETCH_CUSTOM_REPORTS_TO_RUN');
export const fetchCustomReportTypes = getApiActionTypes('FETCH_CUSTOM_REPORT_TO_RUN');
export const runCustomReportTypes = getApiActionTypes('RUN_CUSTOM_REPORT');
export const CLEAN_AFTER_CUSTOM_REPORT = getApiActionTypes('CLEAN_AFTER_CUSTOM_REPORT');
export const CLEAN_AFTER_RUN_CUSTOM_REPORT = 'CLEAN_AFTER_RUN_CUSTOM_REPORT';
